export default __webpack_public_path__ + "static/media/1icon.ea9cb80a.svg";